export function StatsCard({ label, value, testid, accent }) {
  return (
    <div
      data-testid={testid}
      className={`bg-white border ${accent ? "border-[#C5A059]" : "border-[#E5E5E5]"} p-8`}
    >
      <div className="text-xs tracking-[0.25em] uppercase text-[#5C6670]">{label}</div>
      <div className={`font-serif text-5xl mt-3 ${accent ? "text-[#C5A059]" : "text-[#1A1F24]"}`}>
        {(value || 0).toLocaleString()}
      </div>
    </div>
  );
}
